/* Review rotor — cycles the buy-column quotes (sections/main-product.liquid).
   Height is locked to the tallest quote BEFORE rotation starts, so the buy
   column never shifts under the shopper's cursor. Rotation is a courtesy,
   not content: reduced motion, a single quote, or no JS all leave the first
   quote standing (CSS hides the rest), and the interval only runs while the
   rotor is actually on screen and unhovered. */
(function () {
  function boot() {
    var rotors = document.querySelectorAll('[data-review-rotor]');
    if (!rotors.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Array.prototype.forEach.call(rotors, function (rotor) {
      var items = rotor.querySelectorAll('.qrotor__item');
      if (items.length < 2 || reduced) return;

      function measure() {
        rotor.classList.add('is-measuring');
        var h = 0;
        Array.prototype.forEach.call(items, function (el) { h = Math.max(h, el.offsetHeight); });
        rotor.classList.remove('is-measuring');
        rotor.style.minHeight = h + 'px';
      }
      measure();
      rotor.classList.add('is-rotor');

      var at = 0, timer = null, hover = false;
      function next() {
        items[at].classList.remove('is-on');
        at = (at + 1) % items.length;
        items[at].classList.add('is-on');
      }
      function start() {
        if (!timer) timer = setInterval(function () {
          if (!hover && !document.hidden) next();
        }, 6000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.35 }).observe(rotor);
      } else { start(); }

      rotor.addEventListener('mouseenter', function () { hover = true; });
      rotor.addEventListener('mouseleave', function () { hover = false; });

      var rT;
      window.addEventListener('resize', function () {
        clearTimeout(rT);
        rT = setTimeout(function () { rotor.style.minHeight = ''; measure(); }, 200);
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
